import { Injectable } from '@angular/core';
import { Action, State, StateContext, createSelector } from '@ngxs/store';
import { cloneDeep } from 'lodash';
import { SetSetting } from './operations-board-settings.action';
import { QuickFilterType } from '../interfaces/custom-operative-interface';
import { OperationsBoardSetting } from '../interfaces/operations-board-settings';

interface OperationsBoardSettingStateModel {
  settings: {
    [userId in string]: OperationsBoardSetting;
  };
}

const defaultOperationsState: OperationsBoardSettingStateModel = {
  settings: {},
};

@State<OperationsBoardSettingStateModel>({
  name: 'operationsBoardSetting',
  defaults: defaultOperationsState,
})
@Injectable()
export class OperationsBoardSettingState {
  static getSetting(
    userId: string,
  ): (state: OperationsBoardSettingStateModel) => OperationsBoardSetting {
    return createSelector(
      [OperationsBoardSettingState],
      (state: OperationsBoardSettingStateModel) => {
        const setting = state.settings[userId];
        return {
          autoUpdate: setting?.autoUpdate || false,
          organizationUnit: setting?.organizationUnit || [],
          timePeriod: setting?.timePeriod || 0,
          quickFilter: setting?.quickFilter || QuickFilterType.ALL,
        };
      },
    );
  }

  @Action(SetSetting)
  SetSetting(
    ctx: StateContext<OperationsBoardSettingStateModel>,
    { userId, setting }: SetSetting,
  ): void {
    const state = ctx.getState();
    const settingsToUpdate = cloneDeep(state.settings);
    const myUserSettings = settingsToUpdate[userId];

    const updateMyUserSettings = {
      ...myUserSettings,
      ...setting,
    };

    ctx.patchState({
      settings: {
        ...settingsToUpdate,
        [userId]: {
          ...updateMyUserSettings,
        },
      },
    });
  }
}
